function DashboardCard({ icon, colors, title, value }) {
  return (
    <div className="info">
      <div className="icon-wrapper" style={{ backgroundColor: colors[0] }}>
        <embed src={"images/icons/" + icon} width={32} />
      </div>
      <div className="content">
        <div className="value">{value}</div>
        <div className="title">{title}</div>
      </div>
    </div>
  );
}
export default DashboardCard;
